




















































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import ProjectType from "@/models/porposal/projectType.Model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import UserService from '../../../services/user.service';
import { PermissionValue } from '../../../enums/PermissionValue';
@Component
export default class ProjectTypesTableComponent extends GenericBTable<ProjectType> {

  created() {
    this.permissionValue = PermissionValue.TIPOPROYECTO;
    this.tableConfig.controller = "ProjectTypes";
  }

  mounted() {
    this.formatColumns();
  }

  formatColumns() {
    let name = new BTableColumn("name", "table.name", true);
    this.tableConfig.insertColumns(name);
    this.tableConfig.activeActions = this.permissionAccess.write;
    this.tableConfig.actions.customTemplate = this.permissionAccess.write;

  }
}
